export default {
  booking_confirmation_title: 'Boekingsbevestiging',
  booking_confirmation_body: 'Bedankt voor uw boeking. Hieronder vindt u uw bevestigingsdetails.',
  location: 'Locatie',
  pickup_location: 'Ophaallocatie',
  dropoff_location: 'Inleverlocatie',
  vehicle: 'Voertuig',
  pickup_and_dropoff: 'Ophalen en inleveren (lokale tijd)',
  distance_allowance: 'Toegestane kilometers',
  view_voucher: 'Voucher weergeven',
  view_more_bookings: 'Meer boekingen weergeven',
  identity_verification_body: 'U moet uw identiteit verifiëren voordat u uw voertuig ophaalt',
  identity_verification_title: 'Identiteit verifiëren',
  search_again: 'Opnieuw zoeken',
  aircon: 'airco',
  refrigeration: 'Gekoeld',
  not_available: 'Drive &amp; Go is momenteel alleen beschikbaar voor personen met een identiteitsbewijs en rijbewijs uit {profiles}, maar we voegen voortdurend nieuwe landen toe.',
  check_if_included: 'Controleer of uw land erbij staat.',
  included_in_booking: 'Inbegrepen in deze boeking',
  cdw_with_excess: 'Cascoverzekering met eigen risico',
  theft_protection: 'Diefstalbescherming met eigen risico',
  risk_reduction: 'Afkoop eigen risico',
  free_extras: 'U heeft recht op twee gratis extra\'s <br /> bij deze boeking.',
  total_cost: 'Totale huurkosten',
  continue: 'Doorgaan',
  luggage_large_short_label: 'K',
  luggage_medium_short_label: 'M',
  luggage_small_short_label: 'G',
  luggage_large_long_label: 'groot',
  luggage_medium_long_label: 'middel',
  luggage_small_long_label: 'klein',
  fuel_unspecified_label: 'niet opgegeven',
  transmission_manual_label: 'Handgeschakeld',
  transmission_automatic_label: 'Automaat',
  make_a_booking: 'Boeking plaatsen',
  pickup_date: 'Ophaaldatum',
  dropoff_date: 'Inleverdatum',
  driver_age: 'Bestuurder tussen 30 en 65',
  enter_driver_age: 'Voer de leeftijd van de bestuurder in',
  promo_code: 'Promotiecode',
  search: 'Zoeken',
  dropoff_date_cannot_be_before_pickup_date: 'De inleverdatum mag niet eerder zijn dan de ophaaldatum',
  pickup_date_cannot_be_in_the_past: 'De ophaaldatum mag niet in het verleden zijn',
  pickup_time_cannot_be_in_the_past: 'De ophaaltijd mag niet in het verleden zijn',
  dropoff_time_must_be_later_than_the_pickup_time_if_on_the_same_day: 'De inlevertijd moet later zijn dan de ophaaltijd als deze op dezelfde dag is',
  vehicle_filters: 'Voertuigfilters',
  reset: 'Resetten',
  transmission: 'Versnelling',
  all: 'Alles',
  manual: 'Handgeschakeld',
  auto: 'Automaat',
  passengers: 'Passagiers',
  vehicle_type: 'Voertuigtype',
  filter: 'Filteren',
  vehicle_search: 'Voertuig zoeken',
  edit: 'Wijzigen',
  no_results: 'Er zijn geen resultaten voor uw filtercriteria.',
  small_cars: 'Kleine auto\'s',
  medium_cars: 'Middelgrote auto\'s',
  large_cars: 'Grote auto\'s',
  estate_cars: 'Stationwagens',
  suvs: 'SUV\'s',
  mpvs: 'MPV\'s',
  vans: 'Bussen',
  camper_vans: 'Kampeerwagens',
  premium: 'Premium',
  unspecified: 'niet opgegeven',
  large: 'groot',
  medium: 'middel',
  small: 'klein',
  automatic: 'automaat',
  you_have_been_refunded: 'U heeft uw geld teruggekregen.',
  please_customer_service: 'Neem contact op met onze klantenservice om een boeking te plaatsen.',
  contact_customer_service: 'Contact met de klantenservice',
  booking_failed: 'Uw boeking kon op dit moment niet worden verwerkt.',
  summary: 'Samenvatting',
  reforestation_and_protection: 'Steun herbebossing en bescherming van het regenwoud in Costa Rica',
  cost_of_rental: 'Huurkosten',
  to_pay_now: 'Nu te betalen',
  pay_on_arrival: 'Bij aankomst te betalen',
  greenheart_donation: 'Green Heart-donatie',
  tc_agreement: 'Ik heb de {0} geaccepteerd.',
  tc: 'algemene voorwaarden',
  receive_offers: 'Ik wil graag speciale aanbiedingen ontvangen via e-mail',
  donate: 'Ja, ik wil graag {amount} doneren',
  pay_now: 'Nu {amount} betalen',
  driver_details: 'Gegevens bestuurder',
  complete_driver_details: 'Vul de gegevens van de bestuurder in.',
  are_you_the_driver: 'Bent u de bestuurder?',
  have_an_account: 'Heeft u al een account?',
  login: 'Aanmelden',
  or: 'of',
  first_name: 'Voornaam bestuurder',
  last_name: 'Achternaam bestuurder',
  email: 'E-mailadres',
  phone_number: 'Mobiel telefoonnummer',
  unable_to_save_driver_information: 'De bestuurdersgegevens kunnen niet worden opgeslagen. Probeer het opnieuw.',
  pay_on_arrival: 'Bij aankomst betalen',
  pay_online_now: 'Nu online betalen',
  day: 'Dag',
  choose_location: 'Kies een locatie',
  pickup_location: 'Ophaallocatie',
  dropoff_location: 'Inleverlocatie',
  location_not_found: 'Sorry, we konden de gevraagde locatie niet vinden.',
  add: 'Toevoegen',
  remove: 'Verwijderen',
  free_extra: 'Gratis extra',
  free: 'GRATIS!',
  fast_track_notice: 'Voor deze dienst gelden beperkingen voor de documentherkomst. Deze is alleen beschikbaar voor personen met documenten uit',
  complete_booking: 'Boeking voltooien',
  choose_card: 'Kies een kaart of voeg een nieuwe toe.',
  add_billing_details: 'Voeg de factuurgegevens toe.',
  card_number: 'Kaartnummer',
  card_holder_name: 'Naam kaarthouder',
  card_exp: 'MM / JJ',
  card_cvc: 'CVC',
  save_card: 'Kaart opslaan?',
  amount_charged: 'Er wordt een bedrag afgeschreven van uw kaart',
  payment_confirmation: 'Boeking bevestigen en betalen',
  payment_methods: 'beschikbare betaalmethoden',
  use_saved_card: 'x opgeslagen kaart gebruiken',
  use_different_card: '+ andere kaart gebruiken',
  book_now: 'Nu boeken',
  minimum_age: 'Alleen ouder dan {age}',
  excess_liability: 'Eigen risico',
  security_deposit: 'Borgsom',
  fuel_policy: 'Brandstofbeleid',
  like_for_like: 'Zelfde peil terug',
  full_to_full: 'Vol terug',
  miles_per_rental: '{mileage} gratis kilometers per boeking',
  km_per_rental: '{mileage} gratis km per boeking',
  unlimited: 'Onbeperkt',
  unlimited_mileage: 'Onbeperkte kilometers',
  unlimited_mileage_km: 'Onbeperkte km',
  non_amendable: 'Niet wijzigbaar',
  non_refundable: 'Niet restitueerbaar',
  free_cancellation_until: 'Gratis te annuleren tot',
  cancellation_in_line_with: 'Annulering overeenkomstig de',
  tcs: 'Voorwaarden',
  free_extras_on_collection: 'Twee gratis extra\'s bij ophalen',
  glass_and_tyres_covered: 'Ruiten en banden gedekt',
  number_of_passengers: 'Aantal passagiers',
  number_of_bags: 'Aantal tassen',
  fuel_type: 'Brandstoftype',
  co2: 'CO2',
  aircon: 'Airco',
  book_type: '{type} boeken',
  processing: 'Verwerken',
  actual_price: 'Werkelijke prijs',
  tooltip: 'De prijs in ${currencyCode} is een schatting op basis van een wisselkoers, de prijs in ${currency} is bindend.',
  deposit: 'Borg',
  pay_online: 'Nu online betalen',
  pay_online_without_extras: 'Huurprijs',
  extras_on_arrival: 'Extra\'s bij aankomst',
  insurance_on_arrival: 'Afkoop eigen risico - bij aankomst betalen',
  insurance_online: 'Afkoop eigen risico - nu betalen',
  extras_online: 'Extra\'s nu betalen',
  green_heart_donation: 'Green Heart-donatie',
  aircon_lower: 'airco',
  why_use_drive_and_go: 'Waarom Drive & Go gebruiken?',
  straight_to_car: 'Rechtstreeks naar de auto',
  no_queues: 'Geen wachtrijen',
  self_checkout: 'Zelf uitchecken',
  cant_lose_key: 'Sleutel kan niet worden verloren',
  online_id_check: 'Online ID-controle',
  phone_as_key: 'Telefoon als sleutel',
  premiumplus_benefits_includes: 'Premium Plus+-voordelen inbegrepen',
  book_drive_go: 'Drive & Go boeken',
  duration: 'Duur',
  to_pay_on_arrival: 'Bij aankomst te betalen',
  return_date: 'Retourdatum',
  my_profile: null,
  additional_options: 'Aanvullende opties',
  booking_details: 'Boekingsgegevens',
  price_for_x_days: 'Prijs voor {qty_of_days} dag | Prijs voor {qty_of_days} dagen',
  cancelled: 'Geannuleerd',
  upcoming: 'Aankomend',
  active: 'Actief',
  drive_and_go: {
    drive_and_go: 'Drive & Go',
    available_countries: 'Drive &amp; Go is momenteel alleen beschikbaar voor personen met een identiteitsbewijs en rijbewijs uit de volgende landen:',
    drive_and_go_today: 'Drive & Go-boeking vandaag!',
    drive_and_go_shortened: 'Drive & Go',
    why_use_drive_and_go: 'Waarom Drive & Go gebruiken?',
    straight_to_car: 'Rechtstreeks naar de auto',
    no_queues: 'Geen wachtrijen',
    self_checkout: 'Zelf uitchecken',
    cannot_lose_the_key: 'Sleutel kan niet worden verloren',
    online_id_check: 'Online ID-controle',
    phone_as_a_key: 'Telefoon als sleutel',
    premium_plus_benefits_also_included: 'Premium Plus+-voordelen inbegrepen',
    book_drive_and_go: 'Drive & Go boeken',
  },
  my_bookings: "My booking",
  no_bookings: "No booking",
  no_bookings_to_display: 'Geen boekingen om weer te geven.',
  search_great_car_rental_deals: "Search great car rental deals for your next trip.",
  odometer_at_collection: 'Kilometerstand bij ophalen',
  fuel_at_collection: 'Brandstofpeil bij ophalen',
  start_check_in: 'Inchecken starten',
  start_collection: 'Ophalen starten',
  recent_bookings: 'Recente boekingen',
  damage: {
    updated_damage_report_submitted: 'Er is een bijgewerkt schaderapport ingediend. Een medewerker van onze klantenservice neemt indien nodig contact met u op.',
    add_additional_damage: 'Aanvullende schade toevoegen',
    you_may_report_additional_damage_up_to: 'U kunt aanvullende schade melden tot 24 uur na het uitchecken van het voertuig',
    specify_damage: 'Geef de schade op',
    please_choose_the_area_and_type_of_damage: 'Kies het gebied en type van de schade',
    type_of_damage: 'Type schade',
    is_this_more_than_5_cm: 'Is het meer dan 5 cm?',
    please_take_or_select_a_photo: 'Maak of selecteer een foto',
    please_take_a_photo_ensuring_the_damage_is_clearly_visible: 'Maak een foto en zorg dat de schade duidelijk zichtbaar is',
    if_you_require_you_may_add_another_photo_select_the_icon_to_add_another_photo: ' Indien nodig kunt u nog een foto toevoegen. Selecteer het pictogram om nog een foto toe te voegen',
    save_image: 'Afbeelding opslaan',
    save_images: 'Afbeeldingen opslaan',
    damage_saved_successfully: 'Schade opgeslagen',
    add_photo: 'Foto toevoegen'
  },
  checkout: {
    start_collection: 'Ophalen starten',
    collect_vehicle: 'Voertuig ophalen',
    we_will_let_you_know_the_details: 'We laten u de locatie en details weten zodat je het huurvoertuig kunt vinden.',
    inspect: 'Inspecteren',
    we_will_ask_for_four_photos_from_each_corner: 'We vragen u om vier foto\'s van elke hoek van het voertuig, naast eventuele nieuwe schade die nog niet is vermeld.',
    fuel_and_milage: 'Brandstof en kilometerstand',
    you_confirm_the_readings_at_the_start_of_your_hire: 'U bevestigt de kilometerstand en het brandstofpeil aan het begin van uw huurperiode.',
    sign: 'Ondertekenen',
    sign_the_rental_agreement: 'Onderteken de huurovereenkomst.',
    away_you_go: 'Op pad',
    you_are_free_to_take_to_the_road: 'U bent vrij om de weg op te gaan!',
    collect_your_vehicle: 'Haal uw voertuig op',
    get_directions: 'Routebeschrijving ophalen',
    hide_directions: 'Routebeschrijving verbergen',
    local_time: 'lokale tijd',
    tel: 'Tel.',
    getting_to_the_location: 'Naar de locatie gaan',
    get_vehicle_details: 'Voertuiggegevens ophalen',
    view_map: 'Kaart weergeven',
    unlock_vehicle_and_continue: 'Voertuig ontgrendelen en doorgaan',
    unable_to_connect_to_vehicle: 'Kan geen verbinding maken met het voertuig',
    we_were_unable_to_connect_to_the_vehicle_please_check: 'We konden geen verbinding maken met het voertuig. Controleer of u bij het juiste voertuig bent en probeer het opnieuw.',
    we_were_unable_to_find_the_vehicle_booking_please_try_again_later: 'We konden de voertuigboeking niet vinden. Probeer het later opnieuw.',
    odometer_and_fuel: 'Kilometerstand en brandstof',
    odometer: 'Kilometerstand',
    please_confirm_the_odometer_and_fuel_readings: 'Bevestig de kilometerstand en het brandstofpeil.',
    the_odometer_field_is_required: 'Het veld Kilometerstand is verplicht',
    and_must_be_greater_than_the_checkout_odometer: 'en moet hoger zijn dan de kilometerstand bij uitchecken',
    confirm: 'Bevestigen',
    please_take_a_photo_from_each_corner_of_the_vehicle: 'Maak een foto van elke hoek van het voertuig',
    pre_existing_damage: 'Bestaande schade',
    no_pre_existing_damage: 'Geen bestaande schade',
    new_damage: 'Nieuwe schade',
    add_additional_damage: 'aanvullende schade toevoegen',
    no_new_damage_to_report: 'Geen nieuwe schade om te melden',
    checkout_complete: 'Uitchecken voltooid',
    start_rental: 'Huur starten',
    congratulations_name_it_is_time_to_take_to_the_road: 'Gefeliciteerd {customer_name}, het is tijd om de weg op te gaan!',
    we_are_unable_to_complete_your_vehicle_checkout: 'We konden het uitchecken van uw voertuig niet voltooien.',
    please_do_the_following: 'Doe het volgende',
    remove_all_belonging_and_lock_the_vehicle: 'Verwijder alle bezittingen en vergrendel het voertuig.',
    lock_vehicle: 'Voertuig vergrendelen',
    once_you_have_contacted_customer_services: 'Nadat u contact heeft opgenomen met de klantenservice',
    vehicle_location: 'Voertuiglocatie',
    collect_your: 'Haal uw',
    from: 'Van',
    key_in_glove_box: 'uw sleutel bevindt zich in het handschoenenkastje',

    keyholder: {
      not_detected: 'Sleutel niet gedetecteerd in sleutelhouder',
      not_detected_please_try_again: 'Plaats uw sleutel in de sleutelhouder en probeer het opnieuw.',

      not_installed: 'Sleutelhouder niet geïnstalleerd',
      not_installed_please_contact_customer_service: 'Sleutelhouder is niet geïnstalleerd, neem contact op met de klantenservice.',
    },
    keyring: {
      look_up_failed: 'Opzoeken van sleutelhanger is mislukt',
      look_up_failed_please_contact_customer_service: 'Sleutelring opzoeken vals, neem contact op met de klantenservice.',
    },
    key: {
      invalid: 'Sleutel is ongeldig',
      invalid_please_contact_customer_service: 'Uw sleutel is ongeldig, neem contact op met de klantenservice.',

      expired: 'Sleutel is verlopen',
      expired__please_contact_customer_service: 'Uw sleutel is verlopen, neem contact op met de klantenservice.',
    }
  },
  checkin: {
    tell_us_where_you_have_parked: 'Vertel ons waar u het voertuig heeft geparkeerd.',
    fuel_and_milage: 'Brandstof en kilometerstand',
    you_confirm_the_readings_at_the_end_of_your_hire: 'U bevestigt de kilometerstand en het brandstofpeil aan het einde van uw huurperiode.',
    inspect: 'Inspecteren',
    we_will_as_for_four_photos_from_each_corner_of_the_vehicle_along_with_any_new_damage: 'We vragen u om vier foto\'s van elke hoek van het voertuig, naast eventuele nieuwe schade die tijdens de huurperiode is ontstaan.',
    lock: 'Vergrendelen',
    check_you_have_left_no_belonging_then_lock_the_vehicle: 'Controleer dat u geen bezittingen heeft achtergelaten en vergrendel het voertuig.',
    please_tell_us_where_you_have_parked_the_vehicle: 'Vertel ons waar u het voertuig heeft geparkeerd',
    once_the_vehicle_is_locked_you_will_be_unable_to_unlock_it_again: 'Nadat het voertuig is vergrendeld, kunt u het niet meer ontgrendelen.',
    name_please_check_you_have_left_no_belongings_then_lock_the_vehicle: '{first_name}, controleer of je geen spullen hebt achtergelaten, vergrendel het voertuig en lever indien nodig de fysieke sleutel in bij de sleutelhouder.',
    lock_vehicle: 'Voertuig vergrendelen',
    complete_check_in: 'Inchecken voltooien',
    inspection: 'Inspectie',
    complete_vehicle_check_in: 'Inchecken van voertuig voltooien',
    we_are_unable_to_complete_your_vehicle_check_in: 'We konden het inchecken van uw voertuig niet voltooien.',
    please_contact_customer_services: 'Neem contact op met de klantenservice',
    once_you_have_contacted_customer_services: 'Nadat u contact heeft opgenomen met de klantenservice'
  },
  rental_agreement: {
    rental_agreement: 'Huurovereenkomst',
    agreement_between: 'Overeenkomst tussen',
    and: 'en',
    sign_rental_agreement: 'Huurovereenkomst ondertekenen',
    i_have_read_and_understood_the_terms_and_conditions: 'Ik heb de algemene voorwaarden gelezen en begrepen en accepteer de staat van het voertuig'
  },
  full_insurance_no_deposit: 'Volledige verzekering en geen borg vereist',
  excess: '{amount} eigen risico',
  deposit: '{amount} aanbetaling',
  included_daily_distance: '{distance} {unit} per dag',
  miles: 'mijl',
  kilometers: 'kilometers',
  collection_details_title: 'Collectie Details',
  collection_details_not_found: 'Geen ophaalgegevens gedefinieerd voor deze locatie',
  free_cancellation: 'Gratis afzegging',
  no_deposit: 'Geen borg',
  benefit_from: 'voordeel Van',
  for_only_per_day: 'Voor slechts {price} per dag',
  upgrade_mee: 'UpgradeMee'
}
